import React from 'react';

const Header = ({ children }) => (
    <div className="industry-selection-header p-b-4 p-t-12">
        <h4 className="menu-header tbody-7">{children}</h4>
    </div>
);

export default Header;
